module.exports = __webpack_public_path__ + "b5feae52db089949730a5fee72e54aca.svg";